import { defineMessages } from 'react-intl';

export const saveArtefactMessages = defineMessages({
  savedTitle: {
    defaultMessage: 'Saved to Library',
    id: 'booQPaAAmF',
    description: 'Toast title after saving a Work export as a library artefact',
  },
  savedDescription: {
    defaultMessage: 'Find it in the artefacts section of your library.',
    id: 'VROT7xgYBE',
    description: 'Toast body after saving a Work export as a library artefact',
  },
  errorTitle: {
    defaultMessage: 'Could not save artefact',
    id: 'mJSGlFLJ0K',
    description: 'Toast title when saving a Work export to Library fails',
  },
  errorDescription: {
    defaultMessage: 'Please try again.',
    id: 'V2W3igcKKl',
    description: 'Generic toast body when saving a Work export to Library fails',
  },
  buttonLabel: {
    defaultMessage: 'Save as artefact',
    id: '9O/YI4dngO',
    description: 'Button to save a Work export to Library artefacts',
  },
});
